import {Component, OnInit} from '@angular/core';
import {StoreService} from 'src/app/store.service';
import {Router} from '@angular/router';
import {
  AUTO_STYLE,
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import {UtilitiesService} from '../../core/utilities.service';

const DEFAULT_DURATION = 250;

@Component({
  selector: 'notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [
    trigger('collapse', [
      state('false', style({height: AUTO_STYLE, visibility: AUTO_STYLE})),
      state('true', style({height: '0', visibility: 'hidden'})),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ]
})
export class NotificationComponent implements OnInit {
  store_id;
  notification_id;
  is_read;
  notificationData = [];
  notificationCount = 0;
  readStatus: number;
  readChecking: boolean = true;
  notificationId = [];
  notificationIdStore = [];
  notificationStore = [];
  notificationLang: Object;
  notificationContent: Object;
  notificationDate: string;
  notificationArray = [];
  notificationList = [];

  page = 1;
  selectedPage = 10;
  start = 0;
  end = 0;
  loading = true;
  expanded = [];
  isChecks = false;
  showReadButton: boolean = false;
  visible = [false, false];
  showTab = [false, false];

  constructor(
    private svc: StoreService,
    private router: Router,
    private utils: UtilitiesService,
  ) {
  }

  ngOnInit(): void {
    const token = localStorage.getItem('bearer');
    this.svc.getNotification(token).subscribe((res) => {
      this.notification(res);
      this.sliceCart();
      this.loading = false;
      this.notificationArray = res['data'];
    });
  }


  notification(res) {
    if (res['data'].length > 0) {
      res['data'].forEach((value, index) => {
        this.notificationData[index] = [];
        this.notificationData[index]['is_read'] = value.is_read;
        this.notificationData[index]['store_id'] = value.store_id;
        this.notificationData[index]['id'] = value.id;
        this.notificationData[index]['create_at'] = value.created_at;
        this.notificationDate = this.notificationData[index]['create_at'];
        this.store_id = this.notificationData[index]['store_id'];
        this.notification_id = this.notificationData[index]['id'];
        this.notificationIdStore.push(this.notification_id);
        this.notification_id = this.notificationIdStore.join();
        this.readStatus = this.notificationData[index]['is_read'];
        this.notificationData[index]['id'] = value.id;
        this.notificationData[index]['notification_content'] = value.notification_content;
        this.notificationLang = this.notificationData[index]['notification_content']['en-US']['title'];
        this.notificationContent = this.notificationData[index]['notification_content']['en-US']['body'];
        this.notificationCount++;
      });
    }

    this.notificationStore = res['data'];
    if (this.readStatus == 0) {
      this.readChecking = true;
    }
  }

  createNotification() {
    return new Array(this.notificationCount);
  }

  onSave() {
    const token = localStorage.getItem('bearer');
    this.is_read = '1';
    this.svc.updateMarkAsRead(this.notification_id, this.store_id, this.is_read, token).subscribe(res => {
      this.utils.notify.showSuccess(this.utils.translate("Updated Successfully!"));
        setTimeout(() => {
          location.reload();
        }, 3000);
      },
      error => {
        this.utils.notify.showError(this.utils.translate("Update Failed!"));
      });
  }

  onClickCheck(e, id) {
    if (e.target.checked == true) {
      this.showReadButton = true;
      this.notificationId.push(id);
      this.notification_id = this.notificationId.join();
    } else {
      this.showReadButton = false;
      for (var i = 0; i < this.notificationId.length; i++) {
        if (this.notificationId[i] === id) {
          this.notificationId.splice(i, 1);
          this.notification_id = this.notificationId.join();
        }
      }
    }
  }

  checkUncheckAll(e) {
    this.notificationId = [];
    if (e.target.checked == true) {
      this.notification_id = this.notificationIdStore.join();
      this.isChecks = true;
      this.showReadButton = true;
    } else {
      this.isChecks = false;
      this.showReadButton = false;
      this.notification_id = [];
    }

  }

  collapseToggle(id): void {
    this.visible[id] = !this.visible[id];
    this.showTab[id] = this.visible[id] == true;
  }

  sliceCart() {
    this.start = Math.round((this.page - 1) * this.selectedPage);
    this.end = this.start + this.selectedPage;
    this.end = this.end > this.notificationData.length ? this.notificationData.length : this.end;
    this.end = this.end > this.start ? this.end : this.start;
    this.notificationList = this.notificationData.slice(this.start, this.end);
    if (this.notificationList.length > 0) {
      this.notificationList.forEach((value, index) => {
        this.expanded[index] = false;
      });
    }
  }

  selectPage(page: any) {
    this.selectedPage = page;
    this.page = 1;
    this.sliceCart();
  }

  changePage(pageOfItems) {
    this.page = pageOfItems;
    this.sliceCart();
  }

}
